/**
 * Australian financial-year quarter helpers (BAS quarters):
 *   Q1 = Jul 1 – Sep 30
 *   Q2 = Oct 1 – Dec 31
 *   Q3 = Jan 1 – Mar 31
 *   Q4 = Apr 1 – Jun 30
 */

const pad = (n) => String(n).padStart(2, "0");
const iso = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;

/** Returns {year, quarter} for a given Date in AU FY terms. */
export const fyQuarterOf = (d) => {
  const m = d.getMonth() + 1; // 1-12
  const y = d.getFullYear();
  if (m >= 7 && m <= 9) return { quarter: 1, fyStart: y };
  if (m >= 10 && m <= 12) return { quarter: 2, fyStart: y };
  if (m >= 1 && m <= 3) return { quarter: 3, fyStart: y - 1 };
  return { quarter: 4, fyStart: y - 1 };
};

/** Return ISO date strings {from, to, label} for a given fyStart + quarter. */
export const quarterRange = (fyStart, quarter) => {
  const map = {
    1: { fromM: 7, fromD: 1, toM: 9, toD: 30, year: fyStart, toYear: fyStart },
    2: { fromM: 10, fromD: 1, toM: 12, toD: 31, year: fyStart, toYear: fyStart },
    3: { fromM: 1, fromD: 1, toM: 3, toD: 31, year: fyStart + 1, toYear: fyStart + 1 },
    4: { fromM: 4, fromD: 1, toM: 6, toD: 30, year: fyStart + 1, toYear: fyStart + 1 },
  }[quarter];
  return {
    from: iso(map.year, map.fromM, map.fromD),
    to: iso(map.toYear, map.toM, map.toD),
    label: `Q${quarter} FY${String(fyStart).slice(2)}–${String(fyStart + 1).slice(2)}`,
  };
};

/** Range for the current AU financial year (Jul 1 → Jun 30). */
export const fyRange = (fyStart) => ({
  from: iso(fyStart, 7, 1),
  to: iso(fyStart + 1, 6, 30),
  label: `FY${String(fyStart).slice(2)}–${String(fyStart + 1).slice(2)}`,
});

/** Helper presets relative to today. */
export const presetRanges = (now = new Date()) => {
  const cur = fyQuarterOf(now);
  const prevQuarter = cur.quarter === 1 ? 4 : cur.quarter - 1;
  const prevFyStart =
    cur.quarter === 1 ? cur.fyStart - 1 : cur.fyStart;
  return {
    thisQuarter: quarterRange(cur.fyStart, cur.quarter),
    lastQuarter: quarterRange(prevFyStart, prevQuarter),
    thisFY: fyRange(cur.fyStart),
    lastFY: fyRange(cur.fyStart - 1),
  };
};
